import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { PricesApi } from "@/config/apiClient";
import { type ApiErrorResponse } from "@/config/apiClient.types";
import { createApiClient } from "@/config/createApiClient";
import { currentWorkspaceAtom } from "@/store";

const apiClient = createApiClient(PricesApi);

export const usePrice = () => {
  const currentWorkspace = useAtomValue(currentWorkspaceAtom);

  const useGetPrices = (params: {
    catalogMediumId: string;
    selectedConfigurationOptionsIds: Array<string>;
    enabled?: boolean;
  }) => {
    return useQuery({
      queryKey: [
        "getPrices",
        params.catalogMediumId,
        params.selectedConfigurationOptionsIds,
      ],
      queryFn: () => {
        return apiClient.pricesControllerGetProductPrices({
          accountId: currentWorkspace?.accountId,
          organizationId: currentWorkspace?.organizationId,
          workspaceId: currentWorkspace?.id,
          pricesGetCommand: {
            catalogMediumId: params.catalogMediumId,
            selectedConfigurationOptionsIds:
              params.selectedConfigurationOptionsIds,
          },
        });
      },
      // Todo: remove this custom error handling when API will return empty 201 instead of 400
      meta: {
        onError: (error: ApiErrorResponse) => {
          if (error?.status === 400) {
            return true;
          }
          return false;
        },
      },
      enabled:
        !!currentWorkspace &&
        (params.enabled !== undefined ? Boolean(params.enabled) : true),
    });
  };

  return {
    useGetPrices,
  };
};
